// extracted by mini-css-extract-plugin
export var disabled = "_1j-a";
export var hierarchyLinkGray = "_1j-4";
export var hierarchyLinkUnderline = "_1j-3";
export var hierarchyPrimary = "_1j-0";
export var hierarchySecondary = "_1j-1";
export var hierarchyTertiary = "_1j-2";
export var pressed = "_1j-6";
export var themeAction = "_1j-5";
export var themeDestructive = "_1j-8";
export var themeNormal = "_1j-7";
export var themeSuccess = "_1j-9";